import {Routing} from 'nutshell-core/routing';

export const getLinkToImports = (entityPageName: string, originId: string) => {
    const urlParams = {
        fields: {},
        filter: {
            origin: {
                anyAll: 'any',
                data: [{data: originId}],
            },
        },
    } as const;

    if (entityPageName === 'people') {
        // @ts-expect-error
        urlParams.fields = {
            contacts: 'name,lastContactedTime,email,phone,address,tags',
        };
    } else if (entityPageName === 'companies') {
        // @ts-expect-error
        urlParams.fields = {
            accounts: 'name,description,tags,name',
        };
    } else if (entityPageName === 'leads') {
        // @ts-expect-error
        urlParams.fields = {
            fields: {
                leads: 'name,createdTime,value,owner,milestone,confidence,closedTime,sources',
            },
        };
    }

    const paramedNewValue = Routing.param(urlParams);

    return `${entityPageName}?${paramedNewValue}`;
};
